import { Payment } from './../models/payment';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { FormGroup } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { PaymentSecuritiesEventType } from '../payment-securities.event.type';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { PaymentSecuritiesService } from '../services/payment-securities.service';
import { EventTypes } from '../../../shared/EventTypes';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { CpfCnpjPipe } from '../../../shared/cpf-cnpj.pipe';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { ModalAntifraudWarningComponent } from '../../../shared/modal-antifraud-warning/modal-antifraud-warning.component';
import { TransferSituation } from '../../models/transferSituation';
import { MatDialog } from '@angular/material';
import { Util } from '../../../utils/util';
import { PaymentResponseModel } from '../models/payment-response.model';
import { PaymentResponseHandlerService } from '../services/payment-response-handler';
import { PaymentReceiptsService } from '../services/payment-receipt.service';

@Component({
	selector: 'app-payment-securities-confirmation',
	templateUrl: './payment-securities-confirmation.component.html',
	styleUrls: ['./payment-securities-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentSecuritiesConfirmationComponent implements OnInit, OnDestroy {

	@Input() submited = false;
	@Input() paymentData: Payment;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="payment-securities-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedPassword = false;
	public form: FormGroup;
	public isToday: boolean;
	public authorized: boolean;

	active = false;
	disabled = false;
	isSecuritieCip: boolean;
	isSecuritieAgreement: boolean;
	isAttendant = false;

	nameTransfer: string;
	valueTransfer: number;
	dateTransfer: string;
	showAntifraudScreen: boolean = false;

	constructor(
		private paymentService: PaymentSecuritiesService,
		private autenticationService: AutenticationService,
		private themeService: ThemeService,
		public dialog: MatDialog,
		private paymentResponseHandler: PaymentResponseHandlerService,
		private paymentReceiptService: PaymentReceiptsService
	) { }

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();
		AppEventDispatcher.listen(PaymentSecuritiesEventType.STEPS.CONFIRM_PAYMENT, data => {
			if (data.show) {
				this.active = true;
				this.isSecuritieCip = data.securitieCip;
				this.isSecuritieAgreement = data.securitieAgreement;
				this.show(data.securitieCip, data.securitieAgreement);

				this.showStepButtons.emit(false);
			} else {
				this.hide();
			}
		});


		AppEventDispatcher.listen(PaymentSecuritiesEventType.SEND.PAYMENT_DATA_CONFIRM, data => {
			this.send();
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.STEPS.CONFIRM_PAYMENT);
		AppEventDispatcher.removeListener(PaymentSecuritiesEventType.SEND.PAYMENT_DATA_CONFIRM);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedPassword) {
			this.send();
		}
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 80;
	}

	show(securitieCip, securitieAgreement) {

		if (securitieAgreement) {
			this.buildAgreementConfirmList();
		} else {
			this.buildConfirmList();
		}

		const interval = setInterval(() => {

			if ($(this.view).length > 0) {

				TweenMax.delayedCall(.5, () => {
					const containerHeight = this.getStepHeight();
					TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
					TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				});

				clearInterval(interval);
			}

		}, 10);
	}

	buildAgreementConfirmList() {
		this.confirmList = [];
		this.confirmList.push(new ListItem('Linha digitável:', this.paymentData.barCode, 'cls_mask'));
		this.confirmList.push(new ListItem('Beneficiário:', this.paymentData.paymentNameAgreement, 'cls_mask'));
		const FP = new FormatPricePipe();
		this.confirmList.push(new ListItem('Valor:', FP.transform(this.paymentData.value, false), 'cls_mask'));
		this.confirmList.push(new ListItem('Data de pagamento:', moment(this.paymentData.dateLabel).format('DD/MM/YYYY')));
		this.confirmList.push(new ListItem('Nome do pagador:', Util.camelCaseText(Auth.getInstance().getUser().name ? Auth.getInstance().getUser().name : Auth.getInstance().getUser().loggedUserName), 'cls_mask'));
		this.confirmList.push(new ListItem('Cpf/Cnpj do pagador:', Util.maskCpfCnpjPix(Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf), 'cls_mask'));
		this.paymentData.resumeList = this.confirmList;
	}

	buildConfirmList() {
		const FP = new FormatPricePipe();
		const CP = new CpfCnpjPipe();
		this.confirmList = [];
		this.confirmList.push(new ListItem('Linha digitável:', this.paymentData.barCode, 'cls_mask'));
		this.confirmList.push(new ListItem('Valor do pagamento:', FP.transform(this.paymentData.value, false), 'cls_mask'));
		this.confirmList.push(new ListItem('Data de pagamento:', moment(this.paymentData.dateLabel).format('DD/MM/YYYY')));
		if (this.paymentData.assignorName !== undefined) {
			this.confirmList.push(new ListItem('Nome do beneficiário:', this.paymentData.assignorName, 'cls_mask'));
		}
		if (this.paymentData.assignorCpfCnpj !== undefined) {
			this.confirmList.push(new ListItem('Cpf/Cnpj do beneficiário:', Util.maskCpfCnpjPix(this.paymentData.assignorCpfCnpj), 'cls_mask'));
		}
		this.confirmList.push(new ListItem('Agência:', String(this.paymentData.payerAgency)));
		this.confirmList.push(new ListItem('Conta:', String(this.paymentData.payerAccount)));
		this.confirmList.push(new ListItem('Nome do pagador:', Util.camelCaseText(this.paymentData.payerName), 'cls_mask'));
		this.confirmList.push(new ListItem('Cpf/Cnpj do pagador:', Util.maskCpfCnpjPix(this.paymentData.payerCpfCnpj), 'cls_mask'));
		if (this.paymentData.nominalValue) {
			this.confirmList.push(new ListItem('Valor do documento:', FP.transform(this.paymentData.nominalValue, false), 'cls_mask'));
		} else {
			this.confirmList.push(new ListItem('Valor do documento:', FP.transform(this.paymentData.value, false), 'cls_mask'));
		}
		this.confirmList.push(new ListItem('Abatimento do título:', FP.transform(this.paymentData.securitieRebateValue, false), 'cls_mask'));
		this.confirmList.push(new ListItem('Desconto:', FP.transform(this.paymentData.discountValue, false), 'cls_mask'));
		this.confirmList.push(new ListItem('Juros / Mora:', FP.transform(this.paymentData.taxValue, false), 'cls_mask'));
		this.confirmList.push(new ListItem('Multa:', FP.transform(this.paymentData.fineValue, false), 'cls_mask'));
		this.paymentData.chargesValue ? this.confirmList.push(new ListItem('Encargos:', FP.transform(this.paymentData.chargesValue, false), 'cls_mask')) : '';
		this.confirmList.push(new ListItem('Vencimento:', moment(this.paymentData.dueDateInput).format('DD/MM/YYYY')));
		this.paymentData.resumeList = this.confirmList;
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.STEPS.PAYMENT_RESULT, { show: true,
				isSecuritieCip: this.isSecuritieCip, securitieAgreement: this.isSecuritieAgreement });

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});

	}

	send() {

		this.preload(true);
		this.submited = false;
		this.disabled = true;

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.readySend(timeLoader, time);
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	readySend(timeLoader, time) {
		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {

				this.preload(true);

				let secondTime = 1;
				const secondTimeLoader = setInterval(() => {
					secondTime++;
				}, 1000);

				this.confirmPayment(timeLoader, time, secondTimeLoader, secondTime);
			}
		}, error => {
			this.preload(false);
			this.disabled = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.ERROR, { step: PaymentSecuritiesEventType.SEND.PAYMENT_DATA_CONFIRM });
			TweenMax.delayedCall(.5, () => {
				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			});
		});
	}

	confirmPayment(timeLoader, time, secondTime, secondTimeLoader) {
		this.paymentService.confirmPaymentCip(this.paymentData.paymentType, this.paymentData.paymentId ).subscribe(dataForm => {
			if (dataForm.Sucesso) {
				this.paymentData.success = true;
				this.paymentData.confirmationCode = dataForm.Retorno.NroTransacao;
			} else {
				this.paymentData.success = false;
			}

			const processedData = Util.keysToCamel(dataForm.Retorno) as PaymentResponseModel;
			this.paymentData.situation = processedData.situacao;
			const nextView = this.paymentResponseHandler.processResult(processedData, dataForm.Mensagem, this.paymentData);

			if(this.antifraudCanceled(dataForm.Retorno.situacao) && !nextView) {
				this.showAntifraudeModal()
			}

			if (nextView) {
				this.paymentData.message = dataForm.Mensagem;
				this.checkAfterSend(timeLoader, time);
			}
		}, error => {
			this.errorHandler(error, time, timeLoader, secondTime, secondTimeLoader);
			this.disabled = false;
		});
	}

	errorHandler(error, time, timeLoader, secondTime, secondTimeLoader) {
		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
			});
		}

		clearInterval(timeLoader);

		if (error.error.Tipo === 'RequestTimeout') {
			this.paymentData.success = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.INIT, {});
		} else if (error.error.Tipo !== 'tokenDatablinkValidado') {
			this.paymentData.success = false;
			this.paymentData.message =
			error.error ? error.error.Mensagem : 'Não foi possível efetuar o pagamento. Por favor, tente novamente mais tarde.';
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: this.paymentData.message});
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.ERROR, { step: PaymentSecuritiesEventType.SEND.PAYMENT_DATA_CONFIRM });
		} else {
			this.paymentData.success = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			AppEventDispatcher.dispatch(PaymentSecuritiesEventType.ERROR, { step: PaymentSecuritiesEventType.SEND.PAYMENT_DATA_CONFIRM });
		}
	}

	showAntifraudeModal(): void {
			this.dialog.open(ModalAntifraudWarningComponent, {
				data: []
			});
	}

	verifyTransferSituation(situation: string): void {
    if (this.awaitingAntifraudAnalysis(situation)) {
			this.setDataAntifraudScreen();
			return
		}

		if(this.antifraudCanceled(situation)) {
			this.dialog.open(ModalAntifraudWarningComponent, {
				data: []
			});
			return
		}
  }

	awaitingAntifraudAnalysis(situation: string): boolean {
		return situation === TransferSituation.AGUARDANDO_ANALISE_ANTIFRAUDE;
	}

	antifraudCanceled(situation: string): boolean {
		return situation === TransferSituation.CANCELADA_ANTIFRAUDE;
	}

	setDataAntifraudScreen(): void {
		this.nameTransfer = this.paymentData.assignorName;
		this.valueTransfer = this.paymentData.value;
		this.dateTransfer = this.paymentData.dateLabel;
		this.showAntifraudScreen = true;
	}

	checkAfterSend(timeLoader, time) {

		if (time > 3) {
			this.preload(false);
			this.hide();
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
				this.hide();
			});
		}
		clearInterval(timeLoader);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="payment-securities"] .content', show: active, delay: delay});
	}

	clearPreload(time, timeLoader) {
		if (time > 3) {
			this.preload(false);
		} else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false, 3 - time);
			});
		}
		clearInterval(timeLoader);
	}

	public getMessageConfirmedPassword(message: boolean) {
		this.sendConfirmedPassword = message;
	}

	generateReceiptModel(authorized: boolean, isToday: boolean) {
		if (this.isSecuritieAgreement) {
			this.paymentReceiptService.setAgreementReceiptModel(authorized, this.paymentData, isToday);
			return;
		}

		this.paymentReceiptService.setCipReceiptModel(authorized, this.paymentData, isToday);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/payment-securities-confirmation/payment-securities-confirmation.component.ts